import { ref } from "vue";

/**
 * 規約同意チェックボックスの状態管理
 */
export function useTermsAgreement() {
  const isAgreed = ref(false);

  const toggleAgreed = () => {
    isAgreed.value = !isAgreed.value;
  };

  return { isAgreed, toggleAgreed };
}
